export default "__VITE_ASSET__C0tcwe5p__"